export const breakpoints = {
  'mobile-sm': 360,
  mobile: 768,
  tablet: 1024,
  'tablet-lg': 1140,
  desktop: 1400,
};
